import * as React from 'react';

export default function AdMarking() {
    return (
        <div className="admarking">
            <span className="adtext" />
        </div>
    );
}
